'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

exports.default = {
	table: {
		display: 'table',
		width: '100%',
		fontFamily: _styles.typography.fontStack.fontFamily,

		maxHeight: function maxHeight(_maxHeight) {
			var style = {};

			if (_maxHeight) {
				style = {
					overflowY: 'auto',
					maxHeight: _maxHeight
				};
			}

			return style;
		}
	},

	cell: {
		display: 'table-cell',
		verticalAlign: 'middle',
		borderBottom: '1px solid ' + _styles.colors.baseColors.lightGrey,
		paddingRight: '24px'
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTable/styles/index.js